import React, { useCallback, useState } from 'react'
import GenericPopUpModal from 'components/VirtualPortal/components/PopUpModal/GenericPopUpModal'
import HeaderMenu from 'components/VirtualPortal/components/HeaderMenu'
import 'components/VirtualPortal/css/sessions.scss'
import 'components/VirtualPortal/css/buttonSlider.css'

const VirtualPortalHeader = ({ 
  eventName,
  eventHasPeerToPeer,
  eventBeginDate,
  eventBeginTime, 
  eventEndTime,
  eventTimeZone,
  peerToPeerWizardIsAvailable,
  userRegistrationStatus
}) => {
  const [content, setContent] = useState(null)

  if(window.visitingOneOnOneWizardFrom) return ''

  const renderSwitch = useCallback(() => {
    switch (window.currentEvent.id) {
    case 4557:
      return <h5>October 7, 2021 | 8:00am - 3:30pm PDT<br/>October 8, 2021 | 7:00am - 11:30am PDT</h5>
    case 4558:
      return <h5>October 12, 2021 | 8:00am - 4:00pm PDT<br/>October 13, 2021 | 8:00am - 11:30am PDT</h5>
    default:
      return <h5>{eventBeginDate} | {eventBeginTime} - {eventEndTime} {eventTimeZone}</h5>
    }
  },[])

  const infoPopUp = useCallback(() => {
    const content = `<h5>Help & Support</h5>
    <h6>How to create your agenda:</h6>
    <ol>
      <li>Click the ‘+‘ button to add a session to your schedule.</li>
      <li>Click the ‘-‘ button to remove a session from your schedule.</li>
      <li>Select ‘My Schedule‘ to view your selected sessions.</li>
    </ol>
    <hr></hr>
    <h6>Keynote Session:</h6>
    <ul>
      <li>Sessions are open to all participants and led by thought leaders in your community.</li>
    </ul>
    <hr></hr>
    <h6>Boardroom Sessions:</h6>
    <ul>
      <li>Intimate and interactive conversations framed around a hot topic or priority.</li>
      <li>Limited availability based on a first-come, first-served basis.</li>
    </ul>
    <hr></hr>
    <h6>Community Networking:</h6>
    <ul>
      <li>Informal, interactive opportunity for you to network with peers in small groups.</li>
    </ul>
    <hr></hr>
    <h6>Peer to Peer Meetings:</h6>
    <ul>
      <li>Connect with peers in your community in a 1-to-1 setting.</li>
      <li>Available if you signed up prior to the summit.</li>
    </ul>
    </hr>`
    setContent(content)
  },[])

  const closeModal = useCallback(() => setContent(null))

  return(
    <div className='virtual-portal-header'>
      <div className='container'>
        <div className='logo'>
          <img className="logoImageWide" src='/gartner_c_level_communities_white.svg' alt='loading page'/>
          <img className="logoImageStacked" src='/gartner_c_level_communities_white_stacked.png' alt='loading page'/>
        </div>
        <div className='title'>
          <div className='centered'>
            <h4>{ eventName }</h4>
            {renderSwitch()}
          </div>
        </div>
        <div className='info'>
          { eventHasPeerToPeer &&
            <HeaderMenu
              userRegistrationStatus={userRegistrationStatus}
              peerToPeerWizardIsAvailable={peerToPeerWizardIsAvailable}
            />
          }
          <a onClick={infoPopUp}>i</a>
        </div>
      </div>
      {content &&
        <GenericPopUpModal
          customClass="info-pop-up"
          handleCloseGenericModal={closeModal}
          content={content}
          includeChatButton={true}>
        </GenericPopUpModal>
      }
    </div>
  )

}

export default VirtualPortalHeader